import { Component, EventEmitter, Input, Output } from "@angular/core"
import { UserAgentService } from "../../services/user-agent.service"

@Component({
    selector: "app-link-button",
    templateUrl: "./link-button.component.html",
    styleUrls: ["link-button.component.scss"],
})
export class LinkButtonComponent {
    @Input()
    public icon: string

    @Input()
    public tooltip: string

    @Input()
    public label: string

    @Input()
    public hideLabelOnTablet

    @Input()
    public hideLabelOnSmallDevices

    @Input()
    public hideLabelOnMobile

    @Output()
    public trigger = new EventEmitter()

    constructor(public userAgentService: UserAgentService) {}

    public onClick(event: MouseEvent) {
        event.preventDefault()
        this.trigger.next(event)
    }
}
